import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'blog-search',
  templateUrl: './blog-search.component.html',
  styleUrls: ['./blog-search.component.css']
})
export class BlogSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public onClose(){
    this.closeEvent.emit();
  }

  public alphabetList: string[] = ['الف', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ح', 'خ', 'د', 'ذ', 'ر','ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ','ع','غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی']
  @Output() public closeEvent=new  EventEmitter();
}
